import { SurveyResource } from "../services/responses";

export interface OrganizationMetadata extends SurveyResource {}
